import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { formatDate } from "../../../../utils/date";
import { TRIAL_ATTENDANCE_STATUS } from "../../../../constants/enrollments";
import { resolveTrialAttendance } from "../helpers";
import { NeoTable, NeoBadge } from "../../../../components/Common";
import { MaskHelper } from "../../../../utils/helpers";

/**
 * TrialsTable
 * Listagem reativa de Aulas Experimentais utilizando o NeoTable.
 * Apresenta dados cadastrais, cronograma, status de comparecimento e conversões
 * com visual pastificado Taça Outono e zero estilos inline.
 */
const TrialsTable = ({ trials = [], loading = false, filterComponent = null }) => {

    const columns = useMemo(() => [
        {
            label: "Aluno / Lead",
            key: "memberName",
            render: (row) => (
                <div>
                    <Link to={`/members/${row.idMember}`} className="fw-bold text-dark text-truncate d-block neo-truncate-180">
                        {row.memberName || "Aluno Desconhecido"}
                    </Link>
                    {row.memberPhone && (
                        <small className="text-muted d-block mt-0.5">{MaskHelper.phone(row.memberPhone)}</small>
                    )}
                </div>
            )
        },
        {
            label: "Data e Hora",
            key: "sessionDate",
            render: (row) => (
                <div>
                    <span className="fw-semibold text-dark">{formatDate(row.sessionDate)}</span>
                    <small className="text-muted d-block mt-0.5">{row.startTime || "—"}</small>
                </div>
            )
        },
        {
            label: "Atividade",
            key: "activityName",
            render: (row) => <span className="text-muted">{row.activityName || "—"}</span>
        },
        {
            label: "Professor",
            key: "employeeName",
            render: (row) => <span className="text-muted">{row.employeeName || "Não Informado"}</span>
        },
        {
            label: "Consultor(a)",
            key: "consultantName",
            render: (row) => <span className="text-muted">{row.consultantName || "Não Atribuído"}</span>
        },
        {
            label: "Presença",
            key: "attendance",
            align: "center",
            render: (row) => {
                const resolved = resolveTrialAttendance(row);
                if (resolved === TRIAL_ATTENDANCE_STATUS.PRESENT) {
                    return <NeoBadge color="success">Presente</NeoBadge>;
                }
                if (resolved === TRIAL_ATTENDANCE_STATUS.ABSENT) {
                    return <NeoBadge color="danger">Falta</NeoBadge>;
                }
                return <NeoBadge color="primary">Agendado</NeoBadge>;
            }
        },
        {
            label: "Conversão",
            key: "conversion",
            align: "center",
            render: (row) => {
                const resolved = resolveTrialAttendance(row);
                if (row.convertedToSale) {
                    return <NeoBadge color="success" icon="mdi-check-circle">Convertido</NeoBadge>;
                }
                if (resolved === TRIAL_ATTENDANCE_STATUS.PRESENT) {
                    return <NeoBadge color="warning" icon="mdi-clock">Em Andamento</NeoBadge>;
                }
                if (resolved === TRIAL_ATTENDANCE_STATUS.ABSENT) {
                    return <NeoBadge color="danger" icon="mdi-close-circle">Perdido</NeoBadge>;
                }
                return <NeoBadge color="info">Aguardando</NeoBadge>;
            }
        }
    ], []);

    return (
        <NeoTable
            columns={columns}
            data={trials}
            defaultItemsPerPage={10}
            emptyMessage="Nenhuma aula experimental encontrada neste período."
            loading={loading}
            searchComponent={filterComponent}
        />
    );
};

TrialsTable.propTypes = {
    trials: PropTypes.array,
    loading: PropTypes.bool,
    filterComponent: PropTypes.node
};

export default TrialsTable;
